// «سعود» — page adapters for «كل البيانات» (export scope 'all').
//
// A page whose server sends one page of rows at a time needs an adapter: it tells whether more rows exist than the
// page shows (`info`) and fetches them all with the page's own API and current filters (`fetchAll`), capped at
// MAX_ROWS, reporting progress and cancellable. The rows are then laid out in the same columns as the page's table
// (matched by header label), so the actions use the same column keys as the snapshot.
//
// Pages checked (2026-11-01) — only the students list is paged; the others load every row in one request with no
// server cap, so «كل البيانات» there is simply what the page already shows (no adapter, no backend change):
//   /_students/list             POST /user/students/list {q, classname, classroom, sort, page, perpage=100}  → adapter
//   /_students/bis              POST /user/students/bis/all (all rows; class / search filters are client-side)
//   /_students/reports/daily    POST /user/students/reports/daily {date, classname, status, q} (all rows)
//   /_students/reports/between  POST /user/students/reports/between {from, to, classname, q, sort, …} (all rows)
//   /_teachers/list             POST /user/teachers/list (all rows)
//   /_teachers/reports/daily    POST /user/teachers/reports/daily {date} (all rows)
//   /_teachers/reports/between  POST /user/teachers/reports/between {from, to} (all rows)
//   /_students/health           POST /user/students/healths (all rows); student notes open per student (no list)
// Client-paginated vue-good-table / b-table pages need no adapter either: the component holds every row.

import studentsList from './students-list';
export { ownerVm } from './util';

export var MAX_ROWS = 5000;

var ADAPTERS = [studentsList];

// the adapter for this page and table element (or null)
export function adapterFor(route, el){
  for (var i = 0; i < ADAPTERS.length; i++){
    var a = ADAPTERS[i];
    try {
      if (a.match(route) && (!a.selector || (el && el.matches && el.matches(a.selector)))) return a;
    } catch (e) { /* bad selector */ }
  }
  return null;
}

export function adapterByName(name){
  return ADAPTERS.filter(function(a){ return a.name == name; })[0] || null;
}

// fetched items → rows in the table's own column layout (cells by header label)
export function rowsFor(adapter, items, table, vm){
  var width = table.columns.reduce(function(m, c){ return Math.max(m, c.index + 1); }, 0);
  return items.map(function(it){
    var row = new Array(width);
    for (var k = 0; k < width; k++) row[k] = '';
    table.columns.forEach(function(c){
      var fn = adapter.cells[c.label];
      if (!fn) return;
      var v;
      try { v = fn(it, vm); } catch (e) { v = ''; }
      row[c.index] = v == null ? '' : String(v);
    });
    return row;
  });
}

// → { promise: Promise<{ok, rows, capped, message}>, cancel() }
// onProgress(text, fraction|null) while loading
export function fetchAllRows(adapterName, table, onProgress){
  var a = adapterByName(adapterName);
  var el = a && document.querySelector(a.selector || 'table');
  var vm = a && el ? a.vm(el) : null;
  if (!a || !vm){
    return { promise: Promise.resolve({ ok: false, message: 'تعذّر الوصول لبيانات الصفحة. حدّث الصفحة واطلب مرة أخرى.' }), cancel: function(){} };
  }
  var job = a.fetchAll(vm, { cap: MAX_ROWS, onProgress: onProgress || function(){} });
  return {
    cancel: job.cancel,
    promise: job.promise.then(function(r){
      if (!r.ok) return r;
      var items = r.items.slice(0, MAX_ROWS);
      return { ok: true, rows: rowsFor(a, items, table, vm), capped: r.items.length > MAX_ROWS };
    }),
  };
}
